// SPX 0-GEX Levels — TradingView (PineJS) custom study.
//
// Plots the 0-GEX level (gamma flip) as a horizontal line plus the
// ±GEX_NEUTRAL_BAND price corridor (the Neutral zone), computed live from the
// option chain (optionsStore.rowsBySym) via Utils/zeroGex. Mirrors the pattern of
// "SPX Dynamic Levels" (reads a Zustand store inside main(), returns plot values).
// See [[gex-regime-vs-phase]]. NOTE: 0-GEX is SPXGamma's term for what MenthorQ
// calls HVL.

import { useOptionsStore } from '../../Store/optionsStore';
import {
  GEX_NEUTRAL_BAND,
  zeroGexLevel,
  gexBandLevels,
  pointsFromRows,
} from '../../Utils/zeroGex';

export const spxZeroGexGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX 0-GEX Levels',
      metainfo: {
        _metainfoVersion: 53,
        id: 'SPX 0-GEX Levels@tv-basicstudies-1',
        description: 'SPX 0-GEX Levels',
        shortDescription: 'SPX 0-GEX',
        format: { type: 'price' },
        linkedToSeries: true,
        is_price_study: true,
        plots: [
          { id: 'zerogex', type: 'line' },
          { id: 'bandhi', type: 'line' },
          { id: 'bandlo', type: 'line' },
        ],
        filledAreas: [
          {
            id: 'band',
            objAId: 'bandhi',
            objBId: 'bandlo',
            type: 'plot_plot',
            title: '0-GEX Neutral Band',
          },
        ],
        defaults: {
          styles: {
            zerogex: { linestyle: 0, linewidth: 2, transparency: 0, color: '#ffffff' },
            bandhi: { linestyle: 2, linewidth: 1, transparency: 30, color: '#9aa6b2' },
            bandlo: { linestyle: 2, linewidth: 1, transparency: 30, color: '#9aa6b2' },
          },
          filledAreasStyle: {
            band: { color: '#9aa6b2', transparency: 88, visible: true },
          },
        },
        styles: {
          zerogex: { title: '0-GEX (gamma flip)' },
          bandhi: { title: `+${GEX_NEUTRAL_BAND} GEX` },
          bandlo: { title: `-${GEX_NEUTRAL_BAND} GEX` },
        },
        inputs: [],
      },
      constructor: function () {
        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function () {
          try {
            const { rowsBySym, spot } = useOptionsStore.getState();
            if (!rowsBySym) return [NaN, NaN, NaN];

            const pts = pointsFromRows(rowsBySym);
            if (!pts.length) return [NaN, NaN, NaN];

            const level = zeroGexLevel(pts, spot);
            const { lower, upper } = gexBandLevels(pts, GEX_NEUTRAL_BAND, spot);

            return [
              level == null ? NaN : level,
              upper == null ? NaN : upper,
              lower == null ? NaN : lower,
            ];
          } catch (err) {
            console.error('[spxZeroGexGetter] main error:', err);
            return [NaN, NaN, NaN];
          }
        };

        this.destroy = function () {};
      },
    },
  ]);
};
